import { render, staticRenderFns } from "./editCommunityArea.vue?vue&type=template&id=3d4e24a1&scoped=true"
import script from "./editCommunityArea.vue?vue&type=script&lang=js"
export * from "./editCommunityArea.vue?vue&type=script&lang=js"
import style0 from "./editCommunityArea.vue?vue&type=style&index=0&id=3d4e24a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e24a1",
  null
  
)

export default component.exports